module.exports = {
  latlng: [52.52, 13.4],
  zoom: 14,
  title: 'Berlin als Häusermeer',
  introtext:'Wie gut kennen Sie sich in Berlin wirklich aus? Erkennen Sie Berliner Gegenden - nur anhand der Gebäudeumrisse? Machen Sie das Häuserquiz und ordnen Sie den neun Karten die richtigen Orte zu. Wir geben Ihnen zu jedem Ausschnitt einen kleinen Tipp.',
  resultSentences: [
    'Berlin-Verweigerer: Die Stadt interessiert Sie überhaupt nicht.',
    'Tourist: Bitte passen Sie auf, dass Sie sich nicht verlaufen.', 
    'Zugezogener: Ein paar Ecken Berlins kennen Sie immerhin.',
    'Ortskundiger: Sie kennen sich wirklich ganz gut aus in Berlin.',
    'Echter Berliner: Über Berlin muss man Ihnen nichts mehr erzählen.'
  ],
  questions: [
    {
      id: 'Berlin 1',
      lat: 52.513941,
      lng: 13.3521423,
      zoom: 13,
      answers: [
        'Tempelhofer Feld',
        'Volkspark Friedrichshain',
        'Großer Tiergarten'
      ],
      correctAnswer: 'Großer Tiergarten',
      description: 'Wenn mitten in der Stadt einfach die Häuser fehlen.'
    },

    {
      id: 'Berlin 2',
      lat: 52.48298,
      lng: 13.38809,
      zoom: 14,
      answers: [
        'Platz des 18. März',
        'Potsdamer Platz',
        'Platz der Luftbrücke'
      ],
      correctAnswer: 'Platz der Luftbrücke',
      description: 'Der Platz neben Europas flächenmäßig größtem Baudenkmal.'
    },
    {
      id: 'Berlin 3',
      lat: 52.5018656,
      lng: 13.4435225,
      zoom: 15,
      answers: [
        'Oberbaumbrücke',
        'Liebknechtbrücke',
        'Siemenssteg'
      ],
      correctAnswer: 'Oberbaumbrücke',
      description: 'Die Brücke, die auf einem Berliner Bezirkswappen abgebildet ist.'
    },
    {
      id: 'Berlin 4',
      lat: 52.5146492,
      lng: 13.2372503,
      zoom: 14,
      answers: [
        'Stadion Wilmersdorf',
        'Olympiastadion',
        'Mauerpark und Jahnstadion'
      ],
      correctAnswer: 'Olympiastadion',
      description: 'Sport und auch Musik nehmen hier viel Platz ein.'
    },
    {
      id: 'Berlin 5',
      lat: 52.5388742,
      lng: 13.2059823,
      zoom: 14,
      answers: [
        'Alexanderplatz',
        'Altstadt Köpenick',
        'Altstadt Spandau'
      ],
      correctAnswer: 'Altstadt Spandau',
      description: 'Hier befindet sich die größte Fußgängerzone Berlins.'
    },
    {
      id: 'Berlin 6',
      lat: 52.51945,
      lng: 13.39771,
      zoom: 14,
      answers: [
        'Neue Nationalgalerie',
        'Museumsinsel',
        'East Side Gallery'
      ],
      correctAnswer: 'Museumsinsel',
      description: 'Schätze aus aller Welt sind hier zu bewundern.'
    },
    {
      id: 'Berlin 7',
      lat: 52.575288,
      lng: 13.544878,
      zoom: 16,
      answers: [
        'BiotechPark Buch',
        'Tierheim Berlin',
        'Technologiepark Adlershof'
      ],
      correctAnswer: 'Tierheim Berlin',
      description: 'Am Stadtrand liegt die europaweit größte Anlage ihrer Art.'
    },
    {
      id: 'Berlin 8',
      lat: 52.448169,
      lng: 13.448476,
      zoom: 15,
      answers: [
        'Tuschkastensiedlung',
        'Hufeisensiedlung',
        'Falkenhagener Feld'
      ],
      correctAnswer: 'Hufeisensiedlung',
      description: 'Eine der bedeutendsten Siedlungen des sozialen Wohnungsbaus.'
    },
    {
      id: 'Berlin 9',
      lat: 52.497332,
      lng: 13.240867,
      zoom: 16,
      answers: [
        'Der Teufelsberg',
        'Die Humboldthöhe',
        'Großer Bunkerberg'
      ],
      correctAnswer: 'Der Teufelsberg',
      description: 'Die zweithöchste Erhebung Berlins und der höchste Trümmerberg.'
    }/*,
    {
      id: 'Berlin 10',
      lat: 52.503558,
      lng: 13.273918,
      zoom: 14,
      answers: [
        'Tuschkastensiedlung',
        'Messeglände und ICC',
        'Falkenhagener Feld'
      ],
      correctAnswer: 'Messeglände und ICC',
      description: 'XXXXX Messeglände und ICC ...'
    },
    {
      id: 'Berlin 11',
      lat: 52.5516502,
      lng: 13.3795613,
      zoom: 14,
      answers: [
        'Neukölln',
        'Gesundbrunnen',
        'Moabit'
      ],
      correctAnswer: 'Gesundbrunnen',
      description: 'In diesem Stadtteil war die Wiege von Hertha BSC.'
    },

    {
      id: 'Berlin 12',
      lat: 52.5621842,
      lng: 13.3243243,
      zoom: 14,
      answers: [
        'Aussichtspunkt Bohndorf',
        'Kurt-Schumacher-Damm',
        'Sprengelpark'
      ],
      correctAnswer: 'Kurt-Schumacher-Damm',
      description: 'Wo man die startenden Flugzeuge fast anfassen kann.'
    },
    
    {
      id: 'Berlin 13',
      lat: 52.4526154,
      lng: 13.2880058,
      zoom: 14,
      answers: [
        'Freie Universität in Dahlem',
        'Helios Klinikum Berlin-Buch',
        'Grunewald-Grundschule'
      ],
      correctAnswer: 'Freie Universität in Dahlem',
      description: 'Zwischen schicken Villen stehen Gebäude aus "Rost und Silber".'
    }
    */
  ]
}